import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { DetailDrawerType } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../../localized-user-routes-const';
import { UserDetailDrawerTypeKey } from '../../../global/models/user-detail-drawer-type-key.model';
import { COMPLIANCE_PERMISSIONS } from './build-anforderung-detail-drawer-type.function';

/**
 * An Individuelle Anforderung as the detail drawer shows it, behind the same permissions as the
 * Compliance Übersicht. Its `:id` is the UUID that spans its rows at every Standort. Its Aufgaben
 * open a level below it; its Erlass opens as a first level of its own.
 *
 * @param {string} locale - The base language, which localizes the segment
 * @returns {DetailDrawerType} The Individuelle Anforderung's definition for the drawer
 */
export function buildIndividuelleAnforderungDetailDrawerType(locale: string): DetailDrawerType<UserDetailDrawerTypeKey> {
  return {
    segment: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.INDIVIDUELLE_ANFORDERUNGEN][locale],
    label: $localize`:@@compliance.individuelleAnforderung.drawer.typ:Individuelle Anforderung`,
    drawerLabel: $localize`:@@compliance.individuelleAnforderung.drawer.label:Details der individuellen Anforderung`,
    loadComponent: () =>
      import('../pages/individuelle-anforderung-detail-page/individuelle-anforderung-detail-page.component').then(
        (m) => m.IndividuelleAnforderungDetailPageComponent,
      ),
    canActivate: [IsLoggedInGuard, RequiresPermissionGuard],
    data: { requiredAnyPermission: COMPLIANCE_PERMISSIONS },
    contains: ['aufgabe'],
    opens: ['erlass'],
  };
}
